import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { BankAddress } from "./BankAddress";
import { BankDetails } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankDetails";
import { Address } from "../../../../../../../Wrap/Models/Domains/Address/Address";
import {
    Numeric6,
    Numeric8,
    AlphanumericWithSpace,
    AlphanumericWithSpecialCharacters,
    Numeric,
    AlphanumericWithApostrophe,
} from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { IChildComponentProps } from "../../../../../../../react-core/Html/ChildComponent";
import { ValidatorContents } from "../../../../../../Dashboard/Common/ValidatorHelper";

interface IBankThirdPartyProps extends IChildComponentProps<BankAccount> {
    isReview?: boolean;
    label: string;
    onRef: (ref) => void;
}

interface IBankThirdPartyState {}

export class BankThirdParty extends FormComponent<IBankThirdPartyProps, IBankThirdPartyState> {
    constructor(props: any) {
        super(props);
    }

    child: any;

    isValid() {
        const flag = this.child.isValid();
        const self = super.isValid();
        return this.props.isReview || (flag && self);
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onChange(changes: BankAccount) {
        const { data } = this.props;
        for (const key in changes) {
            data[key] = changes[key];
        }
        this.props.onChange(data);
    }

    render() {
        const { data, isReview, label } = this.props;

        return (
            <div className="row">
                <div className="col-xs-12 col-sm-7">
                    <p>{label}</p>
                    <TextBoxEditor
                        disabled={isReview}
                        label="Account Reference:*"
                        required={isReview ? null : "Please enter Account Reference"}
                        value={data.AccountReference}
                        maxLength={45}
                        regex={{ errorMessage: ValidatorContents.AlphaNumericWithSpace, value: AlphanumericWithSpace }}
                        onChange={(v) => this.onChange({ AccountReference: v })}
                    />

                    <TextBoxEditor
                        disabled={isReview}
                        label="Account Name:*"
                        required={isReview ? null : "Please enter Account name"}
                        value={data.AccountName}
                        maxLength={45}
                        regex={{
                            errorMessage: ValidatorContents.AlphanumericWithApostrophe,
                            value: AlphanumericWithApostrophe,
                        }}
                        onChange={(v) => this.onChange({ AccountName: v })}
                    />
                    <TextBoxEditor
                        disabled={isReview}
                        label="Bank Name:*"
                        required={isReview ? null : "Please enter Bank Name"}
                        regex={{
                            errorMessage: ValidatorContents.AlphaNumericWithSpecialCharacters,
                            value: AlphanumericWithSpecialCharacters,
                        }}
                        value={data.BankDetails.Name}
                        maxLength={50}
                        onChange={(v) => this.onBankDetalsNameChange(v)}
                    />
                    <TextBoxEditor
                        disabled={isReview}
                        label="Sort Code:*"
                        value={data.SortCode}
                        required={isReview ? null : "Please enter Sort Code"}
                        regex={{ errorMessage: "Please enter 6 digits", value: Numeric6 }}
                        onChange={(v) => this.onChange({ SortCode: v })}
                    />
                    <TextBoxEditor
                        disabled={isReview}
                        label="Account Number:*"
                        required={isReview ? null : "Please enter Account Number"}
                        value={data.AccountNumber}
                        maxLength={8}
                        regex={{ errorMessage: "Please enter digits", value: Numeric }}
                        onChange={(v) => this.onChange({ AccountNumber: v })}
                    />
                    <BankAddress
                        onChange={(v) => this.onBankDetalsAddressChange(v)}
                        isReview={isReview}
                        address={data.BankDetails.Address}
                        onRef={(ref) => (this.child = ref)}
                    />
                </div>
            </div>
        );
    }

    private onBankDetalsNameChange(name: string): void {
        const { data } = this.props;
        if (name) {
            if (!data.BankDetails) {
                data.BankDetails = this.emptyBankDetail();
            }
            data.BankDetails.Name = name;
        }

        this.props.onChange(JSON.parse(JSON.stringify(data)));
    }

    private onBankDetalsAddressChange(address: Address): void {
        const { data } = this.props;
        if (address) {
            if (!data.BankDetails) {
                data.BankDetails = this.emptyBankDetail();
            }
            data.BankDetails.Address = address;
        }

        this.props.onChange(JSON.parse(JSON.stringify(data)));
    }

    private emptyBankDetail(): BankDetails {
        return { Name: null, Address: null };
    }
}
